// extracted by mini-css-extract-plugin
export default {"App":"App_App__MWTFz","Container":"App_Container__L9Yf-","DeskImg":"App_DeskImg__1QFVk","MobaImg":"App_MobaImg__TJ2ts"};